/**
 * TranscriptPanel: a aba "Transcrição" ligada ao estado da chamada (`TranscriptProvider`): busca e filtro
 * ficam aqui; o texto, os momentos e quem está falando vêm do contexto. "Exportar" baixa o .txt no documento
 * do clique.
 */
import { useCallback, useState } from 'react';
import { useCallTranscript } from './transcriptContext';
import { TranscriptView } from './TranscriptView';
import { buildTranscriptText, downloadText, transcriptFilename } from './exportTranscript';

/**
 * @param {{ title?: string, compact?: boolean }} props `title`: o nome da chamada, para o arquivo exportado.
 *   `compact`: tela estreita (ver `TranscriptView`).
 */
export function TranscriptPanel({ title, compact = false }) {
    const transcript = useCallTranscript();
    const [query, setQuery] = useState('');
    const [filter, setFilter] = useState('all');

    const exportText = useCallback((event) => {
        const { segments, moments, origin, localIdentity } = transcript;
        downloadText(
            transcriptFilename(title),
            buildTranscriptText({ title, origin, segments, moments, localIdentity }),
            event?.currentTarget?.ownerDocument ?? document,
        );
    }, [transcript, title]);

    if (!transcript) return null;
    return (
        <TranscriptView
            status={transcript.status}
            segments={transcript.segments}
            moments={transcript.moments}
            origin={transcript.origin}
            indicators={transcript.indicators}
            localIdentity={transcript.localIdentity}
            transcriberState={transcript.transcriberState}
            diagnosis={transcript.transcriberDiagnosis}
            compact={compact}
            query={query}
            onQueryChange={setQuery}
            filter={filter}
            onFilterChange={setFilter}
            onRemoveMoment={transcript.undoMoment}
            onExport={exportText}
            onRetry={transcript.reload}
        />
    );
}
